import { ArrowDownWideNarrow, ArrowUpNarrowWide, Truck } from "lucide-react";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const Segment = ({ options, value, onChange, prefix }) => (
  <div className="grid grid-cols-3 gap-1 rounded-lg border border-border bg-muted/60 p-1">
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        onClick={() => onChange(option.value)}
        className={`min-h-11 rounded-md px-2 text-xs font-bold transition-[background-color,color,box-shadow] duration-150 ${value === option.value ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}
        data-testid={`${prefix}-${option.value}`}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export const PriceAnalysisFilters = ({ scope, setScope, period, setPeriod, supplier, setSupplier, suppliers, sort, setSort }) => (
  <div className="space-y-2" data-testid="price-analysis-filters">
    <Segment
      prefix="scope-filter"
      value={scope}
      onChange={setScope}
      options={[{ value: "all", label: "Tutto" }, { value: "food", label: "Food" }, { value: "materiali", label: "Packaging" }]}
    />
    <Segment
      prefix="period-filter"
      value={period}
      onChange={setPeriod}
      options={[{ value: "1m", label: "1 mese" }, { value: "3m", label: "3 mesi" }, { value: "all", label: "Tutto" }]}
    />
    <div className="grid grid-cols-[minmax(0,1fr)_auto] gap-2">
      <Select value={supplier} onValueChange={setSupplier}>
        <SelectTrigger className="h-11 min-w-0 rounded-lg" data-testid="supplier-filter-trigger">
          <Truck className="mr-2 h-4 w-4 shrink-0 text-muted-foreground" />
          <SelectValue placeholder="Tutti i fornitori" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="supplier-filter-all">Tutti i fornitori</SelectItem>
          {suppliers.map((item) => (
            <SelectItem key={item.key} value={item.key} data-testid={`supplier-filter-${item.key.replace(/[^a-zA-Z0-9]/g, "-")}`}>
              {item.nome}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        variant="outline"
        onClick={() => setSort(sort === "desc" ? "asc" : "desc")}
        className="h-11 min-w-11 rounded-lg px-3"
        aria-label={sort === "desc" ? "Ordina variazione crescente" : "Ordina variazione decrescente"}
        data-testid="variation-sort-toggle"
      >
        {sort === "desc" ? <ArrowDownWideNarrow className="h-4 w-4" /> : <ArrowUpNarrowWide className="h-4 w-4" />}
        <span className="ml-2 hidden sm:inline">{sort === "desc" ? "% maggiore" : "% minore"}</span>
      </Button>
    </div>
  </div>
);